import React, { ChangeEvent, useContext } from 'react';
import { useIntl } from 'react-intl';
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import * as css from './languageSwitch.module.scss';
import { Language, LanguageContext, toLocaleTag } from './LanguageStore';

const LanguageSwitch: React.FC<
  React.PropsWithChildren<{
    onLanguageChanged: (language: string) => void;
  }>
> = ({ onLanguageChanged }) => {
  const { selectedLanguage, setSelectedLanguage } = useContext(LanguageContext);

  const handleLanguageChanged = (event: ChangeEvent<HTMLInputElement>) => {
    const spraakvalg = (event.target as HTMLInputElement).value;
    setSelectedLanguage(spraakvalg as Language);
    onLanguageChanged(spraakvalg);
  };

  const { formatMessage } = useIntl();

  return (
    <div>
      <FormControl component="fieldset">
        <legend className={css.legend}>
          {formatMessage({ id: 'settings.language.header' })}
        </legend>
        <RadioGroup value={selectedLanguage} onChange={handleLanguageChanged}>
          {Object.keys(Language).map((key) => {
            const languageOption = Language[key as keyof typeof Language];
            return (
              <FormControlLabel
                lang={toLocaleTag(languageOption)}
                key={key}
                value={languageOption}
                control={<Radio color="secondary" />}
                label={formatMessage({
                  id: `settings.language.option.${languageOption}`,
                })}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default LanguageSwitch;
